/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpIcon32Regular = forwardRef('ArrowShapeAUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.527 3.56a3.5 3.5 0 0 1 4.95 0l11.025 11.026c1.26 1.26.368 3.414-1.414 3.414H23v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-8H3.916C2.134 18 1.24 15.846 2.5 14.586L13.527 3.56Zm3.536 1.415a1.5 1.5 0 0 0-2.121 0L3.915 16H10a1 1 0 0 1 1 1v8.998a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8.998a1 1 0 0 1 1-1h6.088L17.063 4.974Z" })));
});
